import SmsProvider from './SmsProvider';

export { SmsProvider };



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsProvider/components/index.js